import { Component, OnInit, Renderer2, inject, ChangeDetectionStrategy } from '@angular/core';
import { TraceClass } from '@sentry/angular';
import { NavigationEnd, Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { MixpanelService } from 'taxtank-core/common';
import { MatDialog } from '@angular/material/dialog';
import { filter, pairwise } from 'rxjs';
import { map } from 'rxjs';
import { ViewportScroller } from '@angular/common';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})
@TraceClass()
export class AppComponent implements OnInit {
  private router = inject(Router);
  private renderer = inject(Renderer2);
  private mpService = inject(MixpanelService);
  private dialog = inject(MatDialog);
  private viewportScroller = inject(ViewportScroller);
  private translate = inject(TranslateService);

  ngOnInit(): void {
    const loaderElement = this.renderer.selectRootElement('#root-preloader');
    this.renderer.setStyle(loaderElement, 'display', 'none');
    this.translate.setFallbackLang('enum');
    this.translate.use('en');
    this.mpService.init();
    this.router.events.pipe(
      filter((e): e is NavigationEnd => e instanceof NavigationEnd),
      map(event => event.urlAfterRedirects.split('?')[0]),
      pairwise(),
    ).subscribe(([previous, current]) => {
      // close modals if page changed
      if (previous !== current) {
        // scroll top
        document.querySelector('.content-wrapper').scrollTop = 0;
        this.closeModals();
      }
      // track page view
      this.mpService.trackPageView();
    });
  }

  // @TODO: taxtankit move close dialog when AbstractDialog will be created
  closeModals(): void {
    if (this.dialog.openDialogs.length) {
      this.dialog.closeAll();
    }
  }
}
